import { LINKS, TRAVEL_LOCATIONS_QUERY } from '@trip-ux/constants';
import { ApiClient } from '../api.client';
import { ReduxStore } from '../payload-types';
import {
  TRAVEL_DESTINATIONS_SEARCH,
  TRAVEL_DEPARTURE_SEARCH,
  TRAVEL_LOCATIONS,
  TRAVEL_LOCATIONS_SUCCESS,
  TRAVEL_LOCATIONS_FAILED,
  SET_SUGGESTED_DEPARTURE_LOCATION,
  SET_SUGGESTED_FURTHEST_DESTINATION
} from './types';
import { Dispatch } from 'redux';

export const searchDepartureLocation =
  (payload: unknown) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: TRAVEL_DEPARTURE_SEARCH,
      payload
    });
  };

export const searchDestinationLocation =
  (payload: unknown) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: TRAVEL_DESTINATIONS_SEARCH,
      payload
    });
  };

export const getTravelLocations =
  (value: string) =>
  (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<unknown> => {
    dispatch({ type: TRAVEL_LOCATIONS });
    return apiClient(dispatch, getState)
      .post(LINKS.GRAPHQL, {
        query: TRAVEL_LOCATIONS_QUERY,
        variables: {
          where: {
            $or: [
              { iata: { $regex: `^${value}`, $options: 'im' } },
              { name: { $regex: `^${value}`, $options: 'im' } },
              { country: { $regex: `^${value}`, $options: 'im' } }
            ]
          }
        }
      })
      .then(({ data }) =>
        dispatch({
          type: TRAVEL_LOCATIONS_SUCCESS,
          payload: { ...data }
        })
      )
      .catch(e => dispatch({ type: TRAVEL_LOCATIONS_FAILED, payload: e }));
  };

export const setSuggestedDepartureLocation =
  (payload: Record<string, string>) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: SET_SUGGESTED_DEPARTURE_LOCATION,
      payload
    });
  };

export const setSuggestedFurthestDestination =
  (payload: Record<string, string>) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: SET_SUGGESTED_FURTHEST_DESTINATION,
      payload
    });
  };
